import cssVars from 'css-vars-ponyfill'
import { ColourScheme, Theme } from '@/types'

export const applyColourScheme = (colours: ColourScheme) => {
  const container = document.querySelector('#colour-scheme')

  container.innerHTML = `
    :root {
      --primary-background: ${colours.primaryBackground};
      --secondary-background: ${colours.secondaryBackground};
      --tertiary-background: ${colours.tertiaryBackground};

      --primary-foreground: ${colours.primaryForeground};
      --secondary-foreground: ${colours.secondaryForeground};
      --tertiary-foreground: ${colours.tertiaryForeground};
    }
  `

  // Polyfill browsers that don't support CSS variables
  // See: https://www.npmjs.com/package/css-vars-ponyfill
  cssVars()
}

export const applyFavicon = (logo: string) => {
  const element = document.querySelector('link[rel="icon shortcut"]')
  element.setAttribute('href', logo)
}

export const applyTheme = (theme: Theme) => {
  applyFavicon(theme.images.favicon)
  applyColourScheme(theme.colours)
}
